import { Component, For } from "solid-js"
import { createStore } from "solid-js/store";
import { Artwork } from "../../types";
import { fetchGet, fetchPost } from "../../API";
import { useGoogleMapsGeocoder } from "../../components/google-maps-geocoder-provider";
import { AddressType, GeocodeResult } from "@googlemaps/google-maps-services-js";

type Props = {
    artwork: Artwork;
    onCancel: () => void;
    onComplete: (address: string) => void;
}

type Model = {
    location: string;
}

export const EditLocationTab : Component<Props>= ({ artwork, onCancel, onComplete }) => {
  const geocoder = useGoogleMapsGeocoder();
    const [model, setModel] = createStore<Model>({
        location: ""
    } as Model);
    const [locations, setLocations] = createStore<GeocodeResult[]>([]);
    const searchForLocationClicked = async (e: Event) => {
        e.preventDefault();
        try {
            // Forward geocoding example
            const results = await geocoder.lookupAddress(model.location);
            setLocations(results);
        } catch (error) {
            console.error("Error in main:", error);
        }
    }
    const getLongName = (type: AddressType, result: GeocodeResult) => {
        const item = result.address_components.find(x => x.types.some(t => t == type));
        return item?.long_name;
    }
    const getShortName = (type: AddressType, result: GeocodeResult) => {
      const item = result.address_components.find(x => x.types.some(t => t == type));
      return item?.short_name;
  }
    const locationClicked = async (location: GeocodeResult) => {
        const data = {
            ArtworkId: artwork.id,
            Premises: getLongName(AddressType.premise, location),
            StreetAddress1: getLongName(AddressType.street_address, location),
            Suburb: getLongName(AddressType.neighborhood, location),
            City: getLongName(AddressType.locality, location),
            StateName: getLongName(AddressType.administrative_area_level_1, location),
            ISO2: getShortName(AddressType.country, location),
            PostalCode: getLongName(AddressType.postal_code, location),
            Latitude: location.geometry.location.lat(),
            Longitude: location.geometry.location.lng(),
        };
        const res = await fetchGet("/Admin/Artwork/SetAddressProperties", data);
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        clearAll();
    }
    const clearAll = () => {
      setModel("location", "");
      setLocations([]);
    }
    const cancelClicked = (e: Event) =>{ 
        e.preventDefault();
        onCancel();
    }
    return (
        <>
            <h2>
                Add/edit depicted location
            </h2>
            <div class="row">
                <div class="col-md-8">
                    <input type="text"
                      value={model.location}
                      onInput={(e) => setModel("location", e.currentTarget.value)}
                      placeholder="Enter address or location"
                      class="form-control"
                    />
                </div>
                <div class="col-md-4">
                    <button onClick={cancelClicked} class="btn btn-default">Cancel</button>
                    <button onClick={searchForLocationClicked} class="btn btn-primary">Find</button>
                </div>
            </div>
            <div style="text-align: left;">
                <table class="table">
                    <tbody>
                        <For each={locations}>{(item) =>
                            <tr>
                                <td>
                                    <button class="btn btn-primary" onClick={(e)=> { e.preventDefault(); locationClicked(item)}} type="button">Select</button>
                                </td>
                                <td>
                                    <label for="">{item.formatted_address}</label>
                                </td>
                            </tr>
                        }</For>
                    </tbody>
                </table>
            </div>
        </>
    )
}